export const sum   = (arr: number[]) => arr.reduce((s, v) => s + v, 0)
export const mean  = (arr: number[]) => arr.length ? sum(arr) / arr.length : 0
export const sd    = (arr: number[]) => {
  if (!arr.length) return 0
  const m = mean(arr)
  return Math.sqrt(mean(arr.map(v => (v - m) ** 2)))
}
export const med   = (arr: number[]) => {
  const s = [...arr].sort((a, b) => a - b)
  const m = Math.floor(s.length / 2)
  return s.length % 2 ? s[m] : (s[m - 1] + s[m]) / 2
}
export const pct   = (n: number, total: number) => total ? Math.round(n / total * 100) : 0
export const f1    = (v: number) => (+v).toFixed(1)
export const count = <T>(arr: T[], fn: (item: T) => boolean) => arr.filter(fn).length
